import React from 'react';
import { CheckIcon } from 'lucide-react';
interface ChoiceChipProps {
  emoji?: string;
  label: string;
  selected: boolean;
  disabled?: boolean;
  onSelect: () => void;
}
export function ChoiceChip({
  emoji,
  label,
  selected,
  disabled = false,
  onSelect
}: ChoiceChipProps) {
  return <button type="button" aria-pressed={selected} disabled={disabled && !selected} onClick={onSelect} className={`flex w-full items-center gap-2.5 rounded-2xl border px-4 py-3.5 text-left text-[15px] font-medium transition-all duration-200 active:scale-[0.97] ${selected ? 'border-violet-500 bg-violet-500/10 text-violet-700 shadow-soft' : 'border-lavender-200 bg-white/90 text-ink shadow-soft'} ${disabled && !selected ? 'opacity-40' : ''}`} data-id="element-18" data-mp="16200ars5c37s">
      {emoji && <span aria-hidden="true" data-id="element-19" data-mp="id71mnk53h9h">{emoji}</span>}
      <span className="flex-1 leading-tight" data-id="element-20" data-mp="ia2q154chj8s">{label}</span>
      {selected && <CheckIcon className="h-4 w-4 shrink-0 text-violet-600" aria-hidden="true" data-id="element-21" data-mp="dbho919g2ri8" />}
    </button>;
}
interface ChoiceCardProps {
  emoji: string;
  title: string;
  description: string;
  selected: boolean;
  disabled?: boolean;
  onSelect: () => void;
}
export function ChoiceCard({
  emoji,
  title,
  description,
  selected,
  disabled = false,
  onSelect
}: ChoiceCardProps) {
  return <button type="button" aria-pressed={selected} disabled={disabled && !selected} onClick={onSelect} className={`flex w-full items-start gap-3.5 rounded-3xl border p-4 text-left transition-all duration-200 active:scale-[0.98] ${selected ? 'border-violet-500 bg-violet-500/10 shadow-lift' : 'border-lavender-200 bg-white/90 shadow-soft'} ${disabled && !selected ? 'opacity-40' : ''}`} data-id="element-22" data-mp="1s1wc7ni2b1wc">
      <span aria-hidden="true" className="grid h-11 w-11 shrink-0 place-items-center rounded-2xl bg-lavender-100 text-xl" data-id="element-23" data-mp="ufp8sgxhvflk">
        {emoji}
      </span>
      <span className="flex-1" data-id="element-24" data-mp="zgmn2ifdvphs">
        <span className="block text-base font-semibold text-ink" data-id="element-25" data-mp="gaf66xib6pqg">{title}</span>
        <span className="mt-0.5 block text-sm leading-snug text-ink-soft" data-id="element-26" data-mp="bj6x62kw56dt">{description}</span>
      </span>
      {selected && <CheckIcon className="mt-1 h-5 w-5 shrink-0 text-violet-600" aria-hidden="true" data-id="element-27" data-mp="6jase14ddax7" />}
    </button>;
}